// Translations for the Card Templates list page (CardTemplates.js).
const cardTemplatesDict = [
  { en: "Failed to load templates", sw: "Imeshindwa kupakia violezo" },
  { en: "Set this template as default?", sw: "Weka kiolezo hiki kama chaguo-msingi?" },
  { en: "Default template updated successfully", sw: "Kiolezo chaguo-msingi kimesasishwa kwa mafanikio" },
  { en: "Failed to set default template", sw: "Imeshindwa kuweka kiolezo chaguo-msingi" },
  { en: "Are you sure you want to delete this template?", sw: "Je, una uhakika unataka kufuta kiolezo hiki?" },
  { en: "Template deleted successfully", sw: "Kiolezo kimefutwa kwa mafanikio" },
  { en: "Failed to delete template", sw: "Imeshindwa kufuta kiolezo" },
  { en: "All Cards", sw: "Kadi Zote" },
  { en: "Standard", sw: "Kawaida" },
  { en: "Premium", sw: "Premium" },
  { en: "Card Templates", sw: "Violezo vya Kadi" },
  { en: "Manage ID card design templates", sw: "Simamia violezo vya muundo wa kadi za utambulisho" },
  { en: "Create New Template", sw: "Unda Kiolezo Kipya" },
  { en: "Card Type", sw: "Aina ya Kadi" },
  { en: "All Types", sw: "Aina Zote" },
  { en: "Status", sw: "Hali" },
  { en: "Active Only", sw: "Zinazotumika Pekee" },
  { en: "All", sw: "Zote" },
  { en: "Loading...", sw: "Inapakia..." },
  { en: "No Templates Found", sw: "Hakuna Violezo Vilivyopatikana" },
  { en: "Create your first card template to get started", sw: "Unda kiolezo chako cha kwanza cha kadi ili kuanza" },
  { en: "Create Template", sw: "Unda Kiolezo" },
  { en: "Default", sw: "Chaguo-msingi" },
  { en: "No description", sw: "Hakuna maelezo" },
  { en: "Type:", sw: "Aina:" },
  { en: "Status:", sw: "Hali:" },
  { en: "Active", sw: "Inatumika" },
  { en: "Inactive", sw: "Haitumiki" },
  { en: "Side:", sw: "Upande:" },
  { en: "Edit", sw: "Hariri" },
  { en: "Set Default", sw: "Weka Chaguo-msingi" },
  { en: "Delete", sw: "Futa" },
  { en: "Created:", sw: "Imeundwa:" },
];

export default cardTemplatesDict;
